import type {Query} from '@/redux/v1/offerAlternativeFlights/models';

export const makeCacheKey = (query: Query): string => {
  return query.offerId;
};
